import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { t } from "../../translations";

import "../styles/section-chef.css";

import PhotoExample from "../../assets/photo-example.png";
import PreviewBanner from "../../assets/preview-banner.png";
import Tips from "../../assets/tips.png";

import { menuService } from "../../services/menuService";

import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { openNotificationWithIcon } from "./notification-bar";

import { Select } from "antd";
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { createLogger } from "../../utils/logger";
import { uploadFile } from "../functions/upload-file";

const logger = createLogger("SelectAddMenu");

const SelectAddMenu = (props) => {
  const { lang, user } = props;
  const history = useHistory();

  const [step, setStep] = useState(0);

  const [selectedCuisine, setSelectedCuisine] = useState(null);
  const [selectedSpicy, setSelectedSpicy] = useState(null);
  const [sideDishSelected, setSideDishSelected] = useState(false);

  const [foodTypeList, setFoodTypeList] = useState([]);
  const [spicyList, setSpicyList] = useState([]);
  const [ingredientList, setIngredientList] = useState([]);
  const [allergensList, setAllergensList] = useState([]);
  const [previewPhoto, setPreviewPhoto] = useState(null);

  const setting = useSelector((state) => state.setting);

  const [load, setLoad] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  // Validation function
  const validateField = (fieldName, value) => {
    const errors = { ...validationErrors };

    if (fieldName === "comment") {
      if (!value || value.trim() === "") {
        errors.comment = "Reheating instructions are required";
      } else {
        delete errors.comment;
      }
    }

    if (fieldName === "expirity") {
      if (!value || value < 1) {
        errors.expirity = "Expiration period must be at least 1 day";
      } else {
        delete errors.expirity;
      }
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Check if current step is valid
  const isStepValid = () => {
    if (step === 4) {
      return (
        detail.comment &&
        detail.comment.trim() !== "" &&
        detail.expirity &&
        detail.expirity >= 1
      );
    }
    return true;
  };

  const [detail, setDetail] = useState({
    chef_id: user?._id,
    name: "",
    food_type: null,
    is_extra: false,
    extra_food: "",
    // food_type: "",
    spice_level: null,
    portion: 1,
    cost: "",
    description: "",
    limit: 1,
    comment: "",
    expirity: 1,
    ingredient: [],
    allergens: [],
    pic: null
  });

  const foodPicRef = useRef(null);
  useEffect(() => {
    initialData();
  }, [user?.refresh_token]); // Only re-run when refresh token changes

  // Synchronize selection states with detail object
  useEffect(() => {
    if (detail.food_type) {
      setSelectedCuisine(detail.food_type);
    }
  }, [detail.food_type]);

  useEffect(() => {
    if (detail.spice_level) {
      setSelectedSpicy(detail.spice_level);
    }
  }, [detail.spice_level]);

  const initialData = async () => {
    setLoad(true);
    try {
      const [allergens, ingredients, spicyLevels, foodTypes] =
        await Promise.all([
          menuService.getAllergens(user?.refresh_token),
          menuService.getIngredients(user?.refresh_token),
          menuService.getSpicyLevels(),
          menuService.getFoodTypes()
        ]);

      setAllergensList(allergens);
      setIngredientList(ingredients);
      setSpicyList(spicyLevels);
      setFoodTypeList(foodTypes);
    } catch (error) {
      logger.error("Error initializing data:", error);
      openNotificationWithIcon("error", t("status.an_error_occure", lang));
    } finally {
      setLoad(false);
    }
  };

  const saveFood = async () => {
    setStep(step + 1);
    setLoad(true);

    if (!detail.pic) {
      return openNotificationWithIcon(
        "error",
        t("validation.a_photo_is_requ", lang)
      );
    }

    if (!detail.comment || detail.comment.trim() === "") {
      setLoad(false);
      setStep(step - 1);
      return openNotificationWithIcon(
        "error",
        "Reheating instructions are required. Please provide detailed reheating instructions."
      );
    }

    if (!detail.expirity || detail.expirity < 1) {
      setLoad(false);
      setStep(step - 1);
      return openNotificationWithIcon(
        "error",
        "Expiration period is required. Please specify how many days the dish remains consumable after delivery."
      );
    }

    const uploadFoodImage = await uploadFile(detail?.pic);

    if (!uploadFoodImage.data.success) {
      setLoad(false);
      return openNotificationWithIcon(
        "error",
        t("status.an_error_occure", lang)
      );
    }

    try {
      await menuService.createFood(
        {
          ...detail,
          pic: uploadFoodImage.data.url
        },
        user?.refresh_token
      );

      setTimeout(() => {
        return history.push("/chef/iam-a-chef/menu");
      }, 1000);
    } catch (error) {
      setStep(step - 1);
      setLoad(false);
      logger.error("Error saving food:", error);
      openNotificationWithIcon("error", t("status.an_error_occure", lang));
    }
  };

  const handleButtonClick = () => {
    return foodPicRef.current.click();
  };

  const handleFileSelect = (event) => {
    const selectedFile = event.target.files[0];

    readFileAsUrl(selectedFile);

    return setDetail({
      ...detail,
      pic: selectedFile
    });
  };

  const readFileAsUrl = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      setPreviewPhoto(reader.result);
    };
    return reader.readAsDataURL(file);
  };

  return (
    <div className="section-chef-menu-right-add-food">
      <div className="section-chef-menu-right-add-food-inside">
        <div
          style={{
            width: "100%",
            height: "85%"
          }}
        >
          {step === 0 && (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <input
                className="input-food-name"
                placeholder={t("common.name_your_dish", lang)}
                name="name"
                value={detail?.name}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    name: e.target.value
                  });
                }}
              />
            </div>
          )}
          {step === 1 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.dish_details", lang)}
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.food_type", lang)}
              </p>
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10
                }}
              >
                {foodTypeList.map((item) => (
                  <div
                    onClick={() => {
                      setSelectedCuisine(
                        //  ? item?.eng_name : item?.name
                        item
                      );
                      return setDetail({
                        ...detail,
                        food_type: item
                        // food_type:  ? item?.eng_name : item?.name
                      });
                    }}
                    style={
                      selectedCuisine === item
                        ? // ( ? item?.eng_name : item?.name)
                          {
                            backgroundColor: "#ffebf0",
                            border: "1px solid #ff114d",
                            color: "#ff114d",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                        : {
                            border: "1px solid #cecece",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                    }
                  >
                    {lang === "en" ? item?.eng_name : item?.name}
                  </div>
                ))}
              </div>
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.does_this_dish_have_side", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.let_the_customer_know_side", lang)}
              </p>
              <div
                style={{
                  display: "flex",
                  gap: 15
                }}
              >
                <label
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 5
                  }}
                >
                  <input
                    type="radio"
                    name="side"
                    value={"yes"}
                    onChange={() => {
                      setDetail({
                        ...detail,
                        is_extra: true
                      });
                      setSideDishSelected(true);
                    }}
                  />{" "}
                  {t("food_view.yes", lang)}
                </label>
                <label
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 5
                  }}
                >
                  <input
                    type="radio"
                    name="side"
                    value={"no"}
                    onChange={() => {
                      setDetail({
                        ...detail,
                        is_extra: false
                      });
                      setSideDishSelected(true);
                    }}
                  />{" "}
                  {t("food_view.no", lang)}
                </label>
              </div>
              {detail?.is_extra === true && (
                <input
                  className="select-address-box"
                  placeholder={t("validation.please_state_th", lang)}
                  placeholderStyle
                  name={"extra_food"}
                  value={detail?.extra_food}
                  onChange={(e) => {
                    setDetail({
                      ...detail,
                      extra_food: e.target.value
                    });
                  }}
                />
              )}
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.spicy_level", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.how_do_you_judg", lang)}{" "}
              </p>
              <div
                style={{
                  marginTop: 20,
                  width: "100%",
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 10
                }}
              >
                {spicyList.map((item) => (
                  <div
                    onClick={() => {
                      setSelectedSpicy(
                        //  ? item?.eng_name : item?.name
                        item
                      );
                      return setDetail({
                        ...detail,
                        spice_level: item
                        // spice_level: item?.name
                      });
                    }}
                    style={
                      selectedSpicy === item
                        ? // ( ? item?.eng_name : item?.name)
                          {
                            backgroundColor: "#ffebf0",
                            border: "1px solid #ff114d",
                            color: "#ff114d",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                        : {
                            border: "1px solid #cecece",
                            padding: 10,
                            borderRadius: 10,
                            cursor: "pointer"
                          }
                    }
                  >
                    {lang === "en" ? item?.eng_name : item?.name}
                  </div>
                ))}
              </div>
            </div>
          )}
          {step === 2 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.package_price", lang)}
              </p>
              {/* <hr /> */}
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.package_size", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.how_many_servin", lang)}
              </p>
              <div
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10
                }}
              >
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.portion === 1) {
                      return;
                    }
                    setDetail({ ...detail, portion: detail.portion - 1 });
                  }}
                >
                  <AiOutlineMinusCircle size={25} />
                </div>
                <div
                  style={{
                    fontSize: 18
                  }}
                >
                  {detail?.portion}
                </div>
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.portion === 10) {
                      return;
                    }
                    setDetail({ ...detail, portion: detail.portion + 1 });
                  }}
                >
                  <AiOutlinePlusCircle size={25} />
                </div>
              </div>
              <hr
                style={{
                  marginTop: 20
                }}
              />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.price", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.we_recommend_en", lang)}
              </p>
              <input
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10
                }}
                type="number"
                min="0"
                step="0.01"
                name={"cost"}
                value={detail?.cost}
                onKeyDown={(e) => {
                  // Prevent typing minus sign
                  if (e.key === "-" || e.key === "e" || e.key === "E") {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const inputValue = e.target.value;
                  // Allow empty string for better UX
                  if (inputValue === "") {
                    setDetail({
                      ...detail,
                      cost: ""
                    });
                    return;
                  }

                  // Check if input has more than 2 decimal places
                  if (inputValue.includes(".")) {
                    const decimalPart = inputValue.split(".")[1];
                    if (decimalPart && decimalPart.length > 2) {
                      // Don't update if more than 2 decimal places
                      return;
                    }
                  }

                  const value = parseFloat(inputValue);
                  // Only update if the value is valid and non-negative
                  if (!isNaN(value) && value >= 0) {
                    setDetail({
                      ...detail,
                      cost: inputValue // Keep the original input string to preserve formatting
                    });
                  }
                  // If invalid or negative, don't update the state (keeps previous valid value)
                }}
              />
              <p
                style={{
                  fontSize: 15,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#ff114d",
                  marginTop: 15
                }}
              >
                {t("commerce.you_earn_by_ord", lang)} {"  "}
                <b>
                  {"$" +
                    (
                      (parseFloat(detail?.cost) || 0) *
                      (1 - (setting?.fee || 0) / 100)
                    ).toFixed(2)}
                </b>
              </p>
            </div>
          )}
          {step === 3 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.description_available", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray"
                }}
              >
                {t("common.description_of_dish", lang)}
              </p>

              <textarea
                className="select-address-box"
                rows={4}
                style={{
                  width: "100%",
                  borderRadius: 5,
                  height: "auto",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 5,
                  backgroundColor: "#f7f7f7"
                }}
                maxLength={400}
                name={"description"}
                value={detail?.description}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    description: e.target.value
                  });
                }}
              />
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: 0
                }}
              >
                {t("common.400_words_maxim", lang)}
              </p>
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("commerce.limit_of_dishes", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("commerce.how_many_orders", lang)}
              </p>
              <input
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  backgroundColor: "#f7f7f7"
                }}
                type="number"
                name={"limit"}
                value={detail?.limit}
                onChange={(e) => {
                  setDetail({
                    ...detail,
                    limit: e.target.value
                  });
                }}
              />
            </div>
          )}
          {step === 4 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.more_informatio", lang)}
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.reheating_instr", lang)}{" "}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray"
                }}
              >
                {t("common.specify_how_man", lang)}{" "}
                <span style={{ color: "red" }}>*</span>
              </p>
              <textarea
                className="select-address-box"
                rows={4}
                style={{
                  width: "100%",
                  borderRadius: 5,
                  height: "auto",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 5,
                  backgroundColor: "#f7f7f7",
                  border:
                    !detail?.comment || detail?.comment.trim() === ""
                      ? "2px solid #ff6b6b"
                      : "1px solid #ddd"
                }}
                maxLength={300}
                name={"comment"}
                value={detail?.comment}
                placeholder="Enter detailed reheating instructions (required)"
                onChange={(e) => {
                  const newValue = e.target.value;
                  setDetail({
                    ...detail,
                    comment: newValue
                  });
                  validateField("comment", newValue);
                }}
              />
              {validationErrors.comment && (
                <p
                  style={{
                    color: "red",
                    fontSize: 14,
                    marginTop: 5,
                    marginBottom: 0
                  }}
                >
                  {validationErrors.comment}
                </p>
              )}
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: 0
                }}
              >
                {t("common.300_words_maxim", lang)}{" "}
              </p>
              <hr />
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.expiration", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("common.the_number_of_d", lang)}{" "}
                <span style={{ color: "red" }}>*</span>
              </p>
              <div
                className="select-address-box"
                style={{
                  width: 200,
                  borderRadius: 40,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: 10,
                  border:
                    !detail?.expirity || detail?.expirity < 1
                      ? "2px solid #ff6b6b"
                      : "1px solid #ddd"
                }}
              >
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.expirity === 1) {
                      return;
                    }
                    const newValue = detail.expirity - 1;
                    setDetail({ ...detail, expirity: newValue });
                    validateField("expirity", newValue);
                  }}
                >
                  <AiOutlineMinusCircle size={25} />
                </div>
                <div
                  style={{
                    fontSize: 18
                  }}
                >
                  {detail?.expirity}
                </div>
                <div
                  className="portion-add"
                  onClick={() => {
                    if (detail?.expirity === 10) {
                      return;
                    }
                    const newValue = detail.expirity + 1;
                    setDetail({ ...detail, expirity: newValue });
                    validateField("expirity", newValue);
                  }}
                >
                  <AiOutlinePlusCircle size={25} />
                </div>
              </div>
              {validationErrors.expirity && (
                <p
                  style={{
                    color: "red",
                    fontSize: 14,
                    marginTop: 5,
                    marginBottom: 0
                  }}
                >
                  {validationErrors.expirity}
                </p>
              )}
            </div>
          )}
          {step === 5 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.ingredients", lang)}
              </p>
              <p
                style={{
                  fontSize: 17,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "gray",
                  marginTop: -10
                }}
              >
                {t("validation.list_the_ingred", lang)}{" "}
              </p>
              <Select
                mode="multiple"
                allowClear
                style={{
                  width: "100%",
                  borderRadius: 15
                }}
                placeholder={t("common.type_and_search", lang)}
                value={detail?.ingredient?.map((item) => item._id) || []}
                onChange={(e) => {
                  logger.debug("Selected ingredient IDs:", e);
                  const newArr = e.map((data) => {
                    return ingredientList.find((item) => item._id === data);
                  });
                  logger.debug("Mapped ingredients:", newArr);
                  setDetail({
                    ...detail,
                    ingredient: newArr
                  });
                }}
                options={ingredientList.map((item) => {
                  return {
                    label: lang === "en" ? item?.eng_name : item?.name,
                    value: item._id
                  };
                })}
              />
              <div
                style={{
                  width: "100%",
                  height: 300,
                  backgroundColor: "#f7f7f7",
                  marginTop: 30,
                  borderRadius: 5
                }}
              >
                <p
                  style={{
                    gap: 10,
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    marginLeft: 20,
                    alignItems: "center"
                  }}
                >
                  <img
                    alt="tips"
                    src={Tips}
                    style={{
                      width: 20
                    }}
                  />{" "}
                  {t("common.tips", lang)}
                </p>
                <ul
                  style={{
                    textAlign: "left",
                    marginLeft: 10
                  }}
                >
                  <li>{t("common.specify_the_typ", lang)} </li>
                  <li>{t("common.seasonings_and_", lang)} </li>
                  <li>{t("common.toppings", lang)}</li>
                  <li>{t("common.the_different_s", lang)} </li>
                  <li>{t("common.list_the_protei", lang)} </li>
                </ul>
              </div>
            </div>
          )}
          {step === 6 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.dietary", lang)}
              </p>
              <p
                style={{
                  fontSize: 20,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000",
                  marginTop: 30
                }}
              >
                {t("common.allergens", lang)}
              </p>
              <Select
                mode="multiple"
                allowClear
                style={{
                  width: "100%",
                  borderRadius: 15
                }}
                placeholder={t("common.type_and_search_1", lang)}
                value={detail?.allergens?.map((item) => item._id) || []}
                onChange={(e) => {
                  logger.debug("Selected allergen IDs:", e);
                  const newArr = e.map((data) => {
                    return allergensList.find((item) => item._id === data);
                  });
                  logger.debug("Mapped allergens:", newArr);
                  setDetail({
                    ...detail,
                    allergens: newArr
                  });
                }}
                options={allergensList.map((item) => {
                  return {
                    label: lang === "en" ? item?.eng_name : item?.name,
                    value: item._id
                  };
                })}
              />
              <div
                style={{
                  width: "100%",
                  height: 300,
                  backgroundColor: "#f7f7f7",
                  marginTop: 30,
                  borderRadius: 5
                }}
              >
                <p
                  style={{
                    gap: 10,
                    fontSize: 16,
                    fontWeight: 600,
                    display: "flex",
                    marginLeft: 20,
                    alignItems: "center"
                  }}
                >
                  <img
                    alt="tips"
                    src={Tips}
                    style={{
                      width: 20
                    }}
                  />{" "}
                  {t("common.tips_1", lang)}
                </p>
                <ul
                  style={{
                    textAlign: "left",
                    marginLeft: 10
                  }}
                >
                  <li>{t("common.specify_the_type", lang)}</li>
                  <li>{t("common.seasonings_and_spices", lang)}</li>
                </ul>
              </div>
            </div>
          )}
          {step === 7 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 24,
                  fontWeight: 500,
                  textAlign: "left",
                  color: "#000"
                }}
              >
                {t("common.photo", lang)}
              </p>
              <ul
                style={{
                  textAlign: "left",
                  color: "#aeaeae"
                }}
              >
                <li>{t("common.use_a_circular_", lang)}</li>
                <li>{t("common.take_the_photo_", lang)}</li>
                <li>{t("common.use_natural_day", lang)}</li>
                <li>{t("common.capture_the_ent", lang)}</li>
              </ul>
              <div
                style={{
                  display: "flex"
                }}
              >
                <img
                  className="img-upload-pic"
                  src={
                    detail?.pic === null
                      ? PreviewBanner
                      : typeof detail?.pic === "string"
                        ? detail?.pic
                        : previewPhoto
                  }
                  alt="img-upload"
                  style={{
                    width: 150,
                    height: 150,
                    borderRadius: 10,
                    objectFit: "contain",
                    border: "1px solid #eeeeee"
                  }}
                  onClick={() => {
                    handleButtonClick();
                  }}
                />
                <input
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  ref={foodPicRef}
                  style={{
                    display: "none"
                  }}
                  onChange={(e) => handleFileSelect(e)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginTop: 15
                }}
              >
                <img
                  src={PhotoExample}
                  style={{
                    width: "100%",
                    maxWidth: 334
                  }}
                  alt="pic-example"
                />
              </div>
            </div>
          )}
          {step === 8 && (
            <div
              style={{
                width: "100%",
                height: "100%"
              }}
            >
              <p
                style={{
                  fontSize: 30,
                  fontWeight: 600,
                  textAlign: "center",
                  color: "#000"
                }}
              >
                {t("validation.please_wait", lang)}
              </p>
              <CircularProgress size={50} />
            </div>
          )}
        </div>
        <div
          style={{
            width: "100%"
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            {[0, 1, 2, 3, 4, 5, 6, 7].map((item) => (
              <div
                style={{
                  width: "11.5%",
                  height: 10,
                  borderRadius: 10,
                  backgroundColor: "#d9d9d9"
                }}
              >
                <div
                  style={{
                    width: step > item ? "100%" : "0%",
                    height: 10,
                    borderRadius: 10,
                    backgroundColor: "#ff114d",
                    transition: "width 0.3s ease"
                  }}
                ></div>
              </div>
            ))}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <div
              className="btn-get-started"
              style={{
                backgroundColor: "#cecece",
                width: 120,
                color: "#000",
                fontSize: 15,
                fontWeight: 600
              }}
              onClick={() => {
                if (load) {
                  return;
                }
                if (step === 0) {
                  return;
                }
                return setStep(step - 1);
              }}
            >
              {!load && t("common.back", lang)}
              {load && <CircularProgress size={25} />}
            </div>
            <div
              className="btn-get-started"
              style={{
                backgroundColor: isStepValid() ? "#ff114d" : "#ccc",
                width: 120,
                cursor: isStepValid() ? "pointer" : "not-allowed"
              }}
              onClick={() => {
                if (load || !isStepValid()) {
                  return;
                }
                if (step === 0) {
                  if (detail?.name?.length < 4) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.give_a_dish_nam", lang)
                    );
                  }
                  return setStep(step + 1);
                }
                if (step === 1) {
                  if (detail?.food_type?.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.select_a_food_t", lang)
                    );
                  }
                  if (detail?.spice_level?.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.select_a_spice_level", lang)
                    );
                  }

                  // Check if side dish question has been answered
                  if (!sideDishSelected) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.select_side_dish_option", lang)
                    );
                  }

                  if (
                    detail?.is_extra === true &&
                    detail?.extra_food.length < 4
                  ) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.write_a_proper_side", lang)
                    );
                  }

                  if (detail?.spice_level === null) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.specify_spicy_level", lang)
                    );
                  }

                  if (detail?.food_type === null) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.select_food_typ", lang)
                    );
                  }

                  return setStep(step + 1);
                }
                if (step === 2) {
                  const costValue = parseFloat(detail.cost) || 0;
                  if (detail.cost === "" || isNaN(costValue)) {
                    return openNotificationWithIcon(
                      "error",
                      "Please enter a valid price."
                    );
                  }
                  if (costValue < 0) {
                    return openNotificationWithIcon(
                      "error",
                      "Price cannot be negative. Please enter a valid price."
                    );
                  }
                  if (costValue < 5) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.price_should_be", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 3) {
                  if (detail.description.length < 30) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.description_sho", lang)
                    );
                  }
                  if (detail.limit < 1 || detail.limit > 28) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.limit_of_dishes", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 4) {
                  // Check if required fields are filled
                  if (!detail.comment || detail.comment.trim() === "") {
                    return openNotificationWithIcon(
                      "error",
                      "Reheating instructions are required. Please provide detailed reheating instructions."
                    );
                  }
                  if (!detail.expirity || detail.expirity < 1) {
                    return openNotificationWithIcon(
                      "error",
                      "Expiration period is required. Please specify how many days the dish remains consumable after delivery."
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 5) {
                  if (detail?.ingredient.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.select_ingredie", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 6) {
                  if (detail?.allergens.length === 0) {
                    return openNotificationWithIcon(
                      "error",
                      t("common.select_allergen", lang)
                    );
                  }
                  return setStep(step + 1);
                }

                if (step === 7) {
                  if (detail?.pic === null) {
                    return openNotificationWithIcon(
                      "error",
                      t("buttons.add_a_food_phot", lang)
                    );
                  }
                  return saveFood();
                }
              }}
            >
              {!load && t("common.next", lang)}
              {load && <CircularProgress size={25} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectAddMenu;
